import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import NumberFormat from 'react-number-format';

import { numberFormatDecimals } from 'constants/formats';
import {
  formatNumber,
  formatNumberDecimals,
  formatNumberDecimalsLong,
} from 'utils/formats';

import MandatoryField from 'modules/_shared/components/MandatoryField';

import InputError from 'modules/_shared/components/InputError';
import { useSplitModal } from '../context/SplitModalContext';

const SplitMovementsView: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useSplitModal();

  const newSharesCount =
    data.societySharesCount * (data.nominalValue / data.newNominalValue);

  return (
    <div>
      <div className="form-group">
        <label className="form-label d-flex w-100 justify-content-between">
          <span className="d-flex align-items-start">
            {t('HowDoYouWantToAssignTheNe')} <MandatoryField />{' '}
          </span>
        </label>

        <div className="row">
          <div className="col-md-4">
            <div className="custom-control custom-radio">
              <input
                type="radio"
                className="custom-control-input"
                id="automatic"
                checked
                onChange={() => {}}
              />
              <label className="custom-control-label" htmlFor="automatic">
                {t('AutomaticBySttok')}
              </label>
            </div>
          </div>

          <div className="col-md-4">
            <div className="custom-control custom-radio">
              <input
                type="radio"
                className="custom-control-input"
                id="manual"
                checked={false}
                onChange={() => {}}
                disabled
              />
              <label className="custom-control-label" htmlFor="manual">
                {t('ManualByPartners')}
              </label>
            </div>
          </div>

          <div className="col-md-4">
            <div className="custom-control custom-radio">
              <input
                type="radio"
                className="custom-control-input"
                id="manual-1"
                checked={false}
                onChange={() => {}}
                disabled
              />
              <label className="custom-control-label" htmlFor="manual-1">
                {t('ManualBySections')}
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="form-group">
        <label className="form-label" htmlFor="pay-amount">
          {t('NewNominalValueForPartici')}
          <br />
          <span className="sub-text">
            {t('CurrentlyTheNominalValueI', {
              nominalValue: formatNumberDecimals(data.nominalValue),
              sharesCount: formatNumber(data.societySharesCount),
            })}
          </span>
        </label>
        <div className="form-control-wrap">
          <NumberFormat
            id="outlined-normal"
            className="form-control form-control-outlined form-control-lg"
            value={data.newNominalValue}
            onChange={actions.handleChangeNewNominalValue}
            required
            decimalSeparator={numberFormatDecimals.decimalSeparator}
            thousandSeparator={numberFormatDecimals.thousandSeparator}
          />
        </div>

        {data.isValidNominalValue ? (
          <span className="form-label">
            {t('NewNominalValue')}:{' '}
            <span className="text-primary">
              {formatNumberDecimalsLong(data.newNominalValue)}
            </span>{' '}
            | {t('NewNumberOfParticipations')}:{' '}
            <span className="text-primary">{formatNumber(newSharesCount)}</span>
          </span>
        ) : (
          <InputError errorMessage={t('TheNewNominalValueIsNotVi')} />
        )}
      </div>
    </div>
  );
};

export default SplitMovementsView;
